import React from "react";

const FormField = ({ label, hint, required, children }) => (
  <div>
    <label className="block text-sm font-medium text-gray-900 mb-1">
      {label}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
    {hint && <p className="text-sm text-gray-500 mb-1.5">{hint}</p>}
    {children}
  </div>
);

export default FormField;
